<div class="end-to-end-knot">
    <ng-container *ngIf="endToEndKnot.iconShape">
        <div
            class="end-to-end-knot__wrapper"
            [ngClass]="{ 'end-to-end-knot__wrapper--highlighted': endToEndKnot.highlighted }"
            aviTitle="{{ endToEndKnot.title }}"
        >
            <cds-icon
                shape="{{ endToEndKnot.iconShape }}"
                badge="{{ endToEndKnot.iconBadge }}"
                status="{{ endToEndKnot.iconStatus }}"
                size="24"
            ></cds-icon>

            <span
                class="end-to-end-knot__title"
                [hidden]="!isExpanded"
            >
                {{ endToEndKnot.title }}
            </span>
        </div>
    </ng-container>

    <ng-container *ngIf="!endToEndKnot.iconShape">
        <div
            class="end-to-end-knot__wrapper"
            [ngClass]="[
                'end-to-end-knot__wrapper-' + endToEndKnot.bridgeColor,
                endToEndKnot.highlighted ? 'end-to-end-knot__wrapper--highlighted' : '',
                endToEndKnot.hasBridge && !isExpanded ? 'end-to-end-knot__wrapper-not-expanded' : ''
            ]"
            aviTitle="{{ endToEndKnot.title }}"
        >
            <span
                class="end-to-end-knot__value-title"
                [hidden]="!isExpanded"
            >
                {{ endToEndKnot.title }}
            </span>

            <span
                class="end-to-end-knot__value"
                [ngClass]="{ 'end-to-end-knot__value-not-expanded': !isExpanded }"
                *ngrxLet="endToEndKnot.value as endToEndKnotValue"
            >
                {{ endToEndKnotValue ?? (globalL10nKeys.notApplicableLabel | vtranslate) }}
            </span>

            <!-- arrow -->
            <double-arrow
                *ngIf="endToEndKnot.hasBridge"
                class="end-to-end-knot__bridge"
                [color]="endToEndKnot.bridgeColor"
                [ngClass]="{ 'end-to-end-knot__bridge-not-expanded': !isExpanded }"
            ></double-arrow>
        </div>
    </ng-container>
</div>
